
import axios from 'axios';

// const baseUrl = 'http://127.0.0.1:8000/';
const baseUrl = 'https://api.cargenie.co.in/';

export function registerUser(obj) {
    return axios({
        url: baseUrl + 'auth/register-consumer',
        method: 'POST',
        data: obj
    })
}

export function login(obj) {
    return axios({
        url: baseUrl + "auth/login",
        method: 'POST',
        data: obj
    })
}

export function fetchOtp(obj) {
    return axios({
        url: baseUrl + 'auth/request-consumer-login-otp',
        method: 'POST',
        data: obj
    })
}

export function matchOtpService(obj) {
    return axios({
        url: baseUrl + 'auth/login-consumer-using-otp',
        method: 'POST',
        data: obj
    })
}

export function getLogout(token) {
    return axios({
        url: baseUrl + 'auth/logout',
        method: 'DELETE',
        headers: {
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        }
    })
    // const response = axios.delete(`${baseUrl}auth/logout`, {
    //     headers: {
    //         'Accept': '*/*',
    //         'Authorization': `Bearer ${token}` 
    //     }
    // })
    // return response
}

export function getUserApi(token) {
    return axios({
        url: baseUrl + 'auth/me',
        method: 'GET',
        headers: {
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        }
    })
}

export function updateProfileApi(obj, token) {
    return axios({
        url: baseUrl + 'auth/update-profile',
        method: 'PATCH',
        data: obj,
        headers: {
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        }
    })
}

export function getBrandsApi(token, page, size) {
    return axios({
        url: baseUrl + 'brand/brands?page=' + page + '&size=' + size,
        method: 'GET',
        headers: {
            'Accept': '*/*',
            'Authorization': `Bearer ${token}`
        }
    })
}

export function getAllModels(page, size, brandId) {
    return axios({
        url: baseUrl + 'model/models?page=' + page + '&size=' + size + '&brandId=' + brandId,
        method: 'GET'
    })
}

export function getVariant() {
    return axios({
        url: baseUrl + 'variant/variants',
        method: 'GET'
    })
}

export function getService() {
    return axios({
        url: baseUrl + 'service/services?page=1&size=50',
        method: 'GET'
    })
}

export function getChildService(parentServiceId) {
    return axios({
        url: baseUrl + "service/services?page=1&size=50&parentServiceId=" + parentServiceId,
        method: 'GET'
    })
}

export function getPrice(page, size, serviceId, brandId, modelId, variantId) {
    return axios({
        url: baseUrl + 'service-price/service-prices?page=' + page + '&size=' + size + '&serviceId=' + serviceId + '&brandId=' + brandId + '&modelId=' + modelId + '&variantId=' + variantId,
        method: 'GET'
    })
}

export function contact(obj, token) {
    return axios({
        url: baseUrl + 'contact-us/contact-us',
        method: 'POST',
        data: obj
    })
}